module.exports = __webpack_public_path__ + "img/大数据图形.38c34edd.png";